import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f5707c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-content" }
const _hoisted_2 = { class: "grid-item" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "date-picker vcfs-date-selector" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-col-centered" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "submit-btn",
    type: "submit"
  }, " CONFIRM PAYMENT ")
], -1))

import { ref, computed } from "vue";
import Popup from "./Popup.vue";
import DatePicker from "./common/DatePicker.vue";
import DateIgnoreTime from "@/types/DateIgnoreTime";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { authService } from "@/auth/authSingleton";
import { vcfsPaymentsService } from "@/services/network";
import { IVcfsPaymentRequest } from "@/Interfaces/Payments/IVcfsPaymentRequest";
import { IVcfsPaymentItem } from "@/Interfaces/Payments/IVcfsPaymentItem";
import { MonetaryValueWithCommas } from "@/services/helpers/Helper";


export default /*#__PURE__*/_defineComponent({
  __name: 'VcfsConfirmPaymentsPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const selectedRow = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
const emits = __emit;

const textInputOptions = { format: "yyyy-MM-dd" };
const today = new Date();
const selectedDate = ref<Date>();
const working = ref(false);

function closeChild() {
    selectedRow.value = undefined;
}
function FormatDatePicker(date: Date){
    return new DateIgnoreTime(date).toString();
}
async function ConfirmPayment() {
    if(working.value == true) return;
    const closeSpinner = useSpinnerPopup().show();
    try{
        working.value = true
        const paymentReference = selectedRow.value?.paymentReference
        if(paymentReference ==undefined)
        {
            useNotifierWithErrFormatter().notify({msg:"Payment reference can not be undefined"})
        }
        const postRequest: IVcfsPaymentRequest = 
        {
            user: authService.getEmailAddress(), 
            date: new DateIgnoreTime(selectedDate.value)
        }
        await vcfsPaymentsService.put(
            { paymentReference: paymentReference as string}, 
            postRequest
        );
    }catch(error){
        useNotifierWithErrFormatter().error({errorType:"VCFS payment confirmation", error})
    }finally{
        closeSpinner();
        working.value = false
        closeChild()
        emits("confirm");
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: !!selectedRow.value,
    "onUpdate:modelValue": closeChild,
    title: "VCFS Payment Confirmation",
    hasClose: ""
  }, {
    contents: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, " Confirming that the payment to VCFS of the amount " + _toDisplayString(_unref(MonetaryValueWithCommas)(selectedRow.value?.amount)) + " has been executed on the following date ", 1),
        _createElementVNode("form", {
          class: "top-content",
          onSubmit: _withModifiers(ConfirmPayment, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(DatePicker, {
              modelValue: selectedDate.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
              placeholder: "Select payment confirmation date...",
              "text-input-options": textInputOptions,
              "max-date": _unref(today),
              "enable-time-picker": false,
              format: FormatDatePicker,
              teleport: true,
              "text-input": "",
              required: ""
            }, null, 8, ["modelValue", "max-date"])
          ]),
          _hoisted_5
        ], 40, _hoisted_3)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})